module.exports = __webpack_public_path__ + "img/sv.fbb15d06.png";